import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
var _ = function _(t) {
    return t;
  },
  _t;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import dayjs from "dayjs";
import css from './style.pcss';
var RTLCountdown = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLCountdown, _LitElement);
  function RTLCountdown() {
    var _this;
    _classCallCheck(this, RTLCountdown);
    _this = _callSuper(this, RTLCountdown);
    _this.hours = "00";
    _this.minutes = "00";
    _this.seconds = "00";
    _this.interval = setInterval(_this._doCountdown.bind(_assertThisInitialized(_this)), 1000);
    return _this;
  }
  _createClass(RTLCountdown, [{
    key: "_mk2chars",
    value: function _mk2chars(minutes) {
      return minutes < 10 ? `0${minutes}` : minutes;
    }
  }, {
    key: "_doCountdown",
    value: function _doCountdown() {
      var now = dayjs();
      var d = dayjs();
      var roundUp = d.minute() || d.second() || d.millisecond() ? d.add(1, 'hour').startOf('hour') : d.startOf('hour');
      var distance = roundUp.valueOf() - now.valueOf();

      //let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(distance % (1000 * 60) / 1000);
      this.hours = this._mk2chars(hours);
      this.minutes = this._mk2chars(minutes);
      this.seconds = this._mk2chars(seconds);
    }
  }, {
    key: "_roundMinutes",
    value: function _roundMinutes(date) {
      //console.log(Math.ceil(date.getMinutes()/60));
      date.setHours(date.getHours() + 1);
      date.setMinutes(0, 0, 0); // Resets also seconds and milliseconds

      return date;
    }
  }, {
    key: "render",
    value: function render() {
      return html(_t || (_t = _`
            <style>${0}</style>
            <div class="rtl-countdown">
                <div class="rtl-countdown__digit rtl-countdown__hours">${0}<span>h</span></div>
                <div class="rtl-countdown__digit rtl-countdown__minutes">${0}<span>m</span></div>
                <div class="rtl-countdown__digit rtl-countdown__seconds">${0}<span>s</span></div>
            </div>
        `), css, this.hours, this.minutes, this.seconds);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        date: {
          type: String
        },
        hours: {
          type: String
        },
        minutes: {
          type: String
        },
        seconds: {
          type: String
        }
      };
    }
  }]);
  return RTLCountdown;
}(LitElement);
export { RTLCountdown as default };
window.customElements.define('rtl-countdown', RTLCountdown);